
import Forget from '../../../statics/illustrations/forgot.svg'
import Formrecover from './formRecover'
const Recover = () => {
  return (
    <div className="container">
      <div className="gs:grid">
        <div className="c-recover-left col-12 lg:col-5">
            <Formrecover/>
        </div>

        <div className="c-recover-right col-12 lg:col-7">
          <span className="c-recover-right__title">Trouble with your password?</span>
          <img src={Forget} alt="forget" className="c-recover-riht__img" />
        </div>

      </div>
    </div>
  )
}

export default Recover